import {AIProviderSettings, providers} from "./AIProvider";
import {Button, Card, Checkbox, Collapse, Flex, Modal, Space, Switch} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown, faCaretRight} from "@fortawesome/free-solid-svg-icons";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {useEffect, useState} from "react";
import {loadAiSettings, saveAiSettings} from "../../feature/project/aiSlice";
import {useParams} from "react-router-dom";
import project from "../../routes/project/Project";

export const AIProviders = (props: {
    settings: AIProviderSettings[],
    onChange: (settings: AIProviderSettings[]) => void
}) => {
    return (
        <Flex vertical={true} gap={10}>
            {providers.map(provider =>
                <Card
                    key={provider.name + props.settings.find(p => p.name == provider.name)?.enabled}
                    title={<Flex align={'center'} gap={10}>{provider.icon}{provider.name}</Flex>}
                    extra={<Switch
                        checked={props.settings.find(p => p.name == provider.name)?.enabled}
                        onChange={(checked, e) => {
                            e.stopPropagation()
                            if (props.settings.find(s => s.name === provider.name)) {
                                props.onChange(props.settings.map(s => s.name === provider.name ? {
                                    ...s,
                                    enabled: checked
                                } : s))
                            } else {
                                props.onChange(props.settings.concat({
                                    name: provider.name,
                                    enabled: checked,
                                    models: [],
                                    apiKey: ''
                                }))
                            }
                        }}
                    />}
                >
                    {provider.settingComponent(
                        {
                            settings: props.settings.find(s => s.name === provider.name) || {
                                name: provider.name,
                                enabled: false,
                                models: [],
                                apiKey: ''
                            },
                            onChange: (settings: AIProviderSettings) => {
                                if (props.settings.find(s => settings.name === s.name)) {
                                    props.onChange(props.settings.map(s => s.name === settings.name ? settings : s))
                                } else {
                                    props.onChange(props.settings.concat(settings))
                                }
                            }
                        }
                    )}
                </Card>
            )}
        </Flex>
    )
}

export const AIProvidersModal = (props: {
    open: boolean,
    onClose: () => void
}) => {
    const dispatch = useAppDispatch()
    const aiProviderSettings = useAppSelector(state => state.aiSlice.aiProviderSettings)
    const [settings, setSettings] = useState<AIProviderSettings[]>([])
    const [loading, setLoading] = useState(false)
    const {projectId} = useParams()

    useEffect(() => {
        if (props.open && projectId) {
            setLoading(true)
            dispatch(
                loadAiSettings()
            ).finally(() => setLoading(false))
        }
    }, [props.open]);

    useEffect(() => {
        setSettings(aiProviderSettings)
    }, [aiProviderSettings])

    return (
        <Modal
            title={'AI Providers'}
            open={props.open}
            onCancel={props.onClose}
            cancelText={'Close'}
            okText={'Save'}
            okButtonProps={{loading: loading}}
            onOk={() => {
                if (projectId) {
                    setLoading(true)
                    dispatch(
                        saveAiSettings({settings: settings})
                    ).finally(() => setLoading(false))
                }
            }}
        >
            <AIProviders
                settings={settings}
                onChange={(settings) => {
                    setSettings(settings)
                }
                }/>
        </Modal>
    )
}

